import SwygWaveMark from '@/components/SwygWaveMark';

type AuthBrandProps = {
  subtitle?: string;
};

/** Shared login / account-creation lockup: wave mark + SWYG wordmark. Never HydroApp / droplet. */
export default function AuthBrand({ subtitle = 'Stay hydrated, stay well' }: AuthBrandProps) {
  return (
    <div className="text-center mb-8" data-testid="auth-brand">
      <SwygWaveMark size="lg" className="mx-auto mb-4" />
      <h1 className="text-3xl font-bold text-deep-800 font-kumbh tracking-tight">SWYG</h1>
      {subtitle ? <p className="text-deep-500 font-kumbh mt-1">{subtitle}</p> : null}
    </div>
  );
}
